import { render } from "./Timer.vue?vue&type=template&id=6737e9ac&scoped=true"
import script from "./Timer.js?vue&type=script&lang=js"
export * from "./Timer.js?vue&type=script&lang=js"

import "./Timer.scss?vue&type=style&index=0&id=6737e9ac&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6737e9ac"]])

export default __exports__